import {
  breadcrumbsIntegration,
  browserProfilingIntegration,
  captureConsoleIntegration,
  consoleLoggingIntegration,
  extraErrorDataIntegration,
  httpClientIntegration,
  init,
  replayIntegration,
} from "@sentry/react"
import { getEnv } from "@/utils"

export default () => {
  init({
    dsn: getEnv("SENTRY_DSN"),
    environment: getEnv("ENVIRONMENT"),
    release: getEnv("RELEASE"),
    enableLogs: true,
    attachStacktrace: true,
    normalizeDepth: 10,
    integrations: [
      consoleLoggingIntegration({
        levels: ["info", "warn", "error", "log", "assert"],
      }),
      captureConsoleIntegration({ levels: ["error", "assert"] }),
      extraErrorDataIntegration(),
      httpClientIntegration(),
      // Click breadcrumbs otherwise serialise as the element's Tailwind class
      // soup, which says nothing about what was clicked. data-sentry="…" on a
      // control makes its breadcrumb read as the control's name instead.
      breadcrumbsIntegration({
        dom: { serializeAttribute: ["data-sentry", "data-slot"] },
      }),
      browserProfilingIntegration(),
      // Session replay, in buffer mode: nothing is uploaded until an error is
      // captured, at which point the preceding ~60s is attached to it. That
      // keeps the replay quota spent on sessions that actually broke.
      // Masking matches the SDK defaults, set explicitly so it cannot drift:
      // respondents' answers must never leave the browser.
      replayIntegration({
        maskAllText: true,
        maskAllInputs: true,
        blockAllMedia: true,
      }),
    ],
    ignoreErrors: [],
    tracesSampleRate: 1.0,
    // The API is same-origin in every environment (profiling.wip locally,
    // review.profiling.app / staging.profiling.app / profiling.app deployed),
    // so propagate to our own hosts and nowhere else. This used to read
    // profiling.com, which matches no environment we have ever run — backend
    // spans never joined the frontend trace.
    tracePropagationTargets: [/^https:\/\/([a-z0-9-]+\.)*profiling\.(app|wip)/],
    profileSessionSampleRate: 0.1,
    profileLifecycle: "trace",
    // Buffer mode: never sample plain sessions, always keep the buffer of a
    // session that hit an error.
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  })
}
